import type React from "react";
import type { PropsWithChildren } from "react";
import { Text, type TextProps } from "tamagui";
import tamaguiConfig from "../../tamagui.config";
import { Input, type InputProps } from "./InputNew";
import { Skeleton } from "./Skeleton";

const subtextStyle = {
  color: "$muted",
  fontFamily: "$subtext",
  fontWeight: "$true",
  lineHeight: "$true",
  fontSize: "$true",
} as const;

export const Subtext: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  ...props
}) => {
  return (
    <Text {...subtextStyle} {...props}>
      {children}
    </Text>
  );
};

export const SubtextTextarea: React.FC<InputProps> = (props) => {
  return <Input {...subtextStyle} {...props} />;
};

export const SubtextSkeleton: React.FC = () => {
  return (
    <Skeleton
      width={"50%"}
      height={tamaguiConfig.fonts.subtext.lineHeight.true}
    />
  );
};
